import Avatar from '@ui/Avatar';
import Typography from '@ui/Typography';
import React from 'react';
import Link from '@ui/Link';
import { first, isArray, kebabCase, size } from 'lodash-es';
import DonateButton from '../next-page-components/DonateButton';

function ActivitySuccessNonProfitBar(props) {
  const {
    post = null,
    user = null,
    donate = false,
    isPost = false,
    company = null,
    supportedNonProfit = null,
    nonProfit,
  } = props;
  //   const withDonate = !!post;
  const asLink = !!post;

  if ((!nonProfit && !company && !user) || nonProfit?.blocked) {
    return null;
  }

  if (isPost) {
    return (
      <div className="flex items-center justify-between gap-2 bg-primary-light-1 px-6 py-4 lg:px-8">
        <div className="flex items-center justify-start gap-2.5 lg:gap-4">
          <Avatar
            src={nonProfit?.logo_url || user?.avatar}
            alt={nonProfit?.name || user?.first_name}
            size="md"
          />
          <Typography variant="h3" component="h1" className="">
            Dear {user?.first_name || 'user'}, Your social impact sparkles
            brightly!
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4 flex items-center justify-between gap-2 bg-primary-light-1 px-6 py-6 lg:px-8">
      <div className="flex items-center justify-start gap-2.5 lg:gap-4">
        <Avatar src={nonProfit?.logo_url} alt={nonProfit?.name} size="md" />
        {/* //TODO: check */}
        {nonProfit ? (
          supportedNonProfit ? (
            <>
              <Typography variant="h3" component="h1" className="">
                {nonProfit?.name}
              </Typography>
              <Typography variant="h3" color="textDisabled">
                supporting
              </Typography>
              <Link
                href={`/${
                  supportedNonProfit?.slug
                    ? supportedNonProfit.slug
                    : 'nonprofit/' + kebabCase(supportedNonProfit.name)
                }-${supportedNonProfit.id}`}>
                <Typography
                  variant="h3"
                  color="primary"
                  className="group-hover:text-text-hyperlink">
                  {supportedNonProfit.name}
                </Typography>
              </Link>
            </>
          ) : (
            <>
              <Typography variant="h3" component="h1" className="">
                {nonProfit?.name}
              </Typography>
            </>
          )
        ) : asLink && nonProfit.slug ? (
          <Link href={`/${nonProfit.slug}-${nonProfit.id}`}>
            <Typography
              variant="h3"
              component="h1"
              className="group-hover:text-text-hyperlink">
              {nonProfit?.name}
            </Typography>
          </Link>
        ) : (
          <Typography variant="h3" component="h1">
            {nonProfit?.name}
          </Typography>
        )}
      </div>
      {/* {withDonate && (
        <DonateButton
          variant="outlined"
          nonProfit={nonProfit}
          post={post}
          withIcon
          className="flex-shrink-0 flex-grow-0"
        />
      )} */}
    </div>
  );
}

export default ActivitySuccessNonProfitBar;
